module.exports = __webpack_public_path__ + "static/content-communications-mobile-d550c9b8bc7d7081b92b111c65696f04.png";